export default "__VITE_ASSET__Wb6wFb0Z__"